export default __webpack_public_path__ + "static/media/setLogo.516ff485.webp";